import { handleError } from "core/utils/HandleError";
import { chatHttpClient } from "core/utils/HttpSocketClient";

export function joinTournamentChat({
  userId,
  roomId,
}: {
  userId: number;
  roomId: string;
}) {
  return chatHttpClient.post(`/rooms/${roomId}/users/${userId}`, {})
    .then((response) => response.data)
    .catch(handleError);
}

export function removeTournamentChat({
  userId,
  roomId,
}: {
  userId: number;
  roomId: string;
}) {
  return chatHttpClient.delete(`/rooms/${roomId}/users/${userId}`)
    .then((response) => response.data)
    .catch(handleError);
}

export function getTournamentChatMessages({
  limit,
  roomId,
  page,
}: {
  limit: number;
  roomId: string;
  page: number;
}) {
  return chatHttpClient.get(`/rooms/group/${roomId}/messages`, {
    params: { limit, page },
  })
    .then((response) => response.data)
    .catch(handleError);
}

export function checkUserInGroup({
  roomId,
  userId,
}: {
  roomId: string;
  userId: number;
}) {
  return chatHttpClient.get(`/rooms/group/${roomId}/is-user/${userId}`)
    .then((response) => response.data)
    .catch(handleError);
}

export function addUserToRoom({
  roomId,
  userId,
}: {
  roomId: string;
  userId: number;
}) {
  return chatHttpClient.post(`/rooms/${roomId}/users/${userId}`)
    .then((response) => response.data)
    .catch(handleError);
}
